/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Spinner } from 'reactstrap';
import { useHistory } from 'react-router-dom';

import { Container } from '~/styles/pagesStyle';

import Menu from '~/components/Menu';
import Card from './Card';

import api from '~/services/api';
import { handleRegisterMenu } from '../MenuServices';
import Footer from '~/components/Footer';

const initialForm = {
  descricao: '',
  nomeImagem: '',
  url: '',
};

function MenuCadastro() {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [modulos, setModulos] = useState([{}]);
  const [form, setForm] = useState(initialForm);

  useEffect(() => {
    setLoading(true);
    async function getData() {
      await api
        .get('Modulo/GetPaginado/Page/1/Length/1000')
        .then((response) => {
          const { registros } = response.data;
          setModulos(registros);
          setLoading(false);
        })
        .catch(() => {
          toast.error('Erro ao buscar dados, recarregue a página');
        });
    }
    getData();
  }, []);

  async function handleSubmit(e) {
    if (!form.nome) {
      toast.error('Nome é obrigatório');
      return;
    }
    if (!form.descricao) {
      toast.error('Descrição é obrigatório');
      return;
    }
    if (!form.idModulo) {
      toast.error('Módulo é obrigatório');
      return;
    }
    if (!form.tipoPagina) {
      toast.error('Tipo de página é obrigatório');
      return;
    }
    if (!form.ordem) {
      toast.error('Ordem é obrigatório');
      return;
    }
    if (!form.idSituacaoCadastral) {
      toast.error('Situação cadastral é obrigatório');
      return;
    }
    const usuarioLogado = sessionStorage.getItem('@auth/userName');
    e.preventDefault();
    setLoading(true);
    const menu = {
      id: 0,
      idModulo: form.idModulo,
      idSituacaoCadastral: form.idSituacaoCadastral,
      nome: form.nome,
      descricao: form.descricao,
      nomeImagem: form.nomeImagem === '' ? null : form.nomeImagem,
      ordem: form.ordem,
      url: form.tipoPagina === 'O' ? form.url : null,
      tipoPagina: form.tipoPagina,
      dataInclusao: null,
      usuario: usuarioLogado,
      excluido: true,
    };
    await handleRegisterMenu(menu, setLoading);
    history.push('/menu/list');
  }

  return (
    <Container>
      <Footer />
      <Menu />
      {loading ? (
        <Spinner style={{ height: '3rem', width: '3rem', margin: '5% auto' }} />
      ) : (
        <Card
          modulos={modulos}
          loading={loading}
          setForm={setForm}
          form={form}
          handleSubmit={handleSubmit}
        />
      )}
    </Container>
  );
}

export default MenuCadastro;
